// initial state
const state = {
  index: 0
}

const actions = {
  increaseStep: ({ state, commit }) => {
    commit('changeIndex', state.index + 1)
  },

  decreaseStep: ({ state, commit }) => {
    commit('changeIndex', state.index - 1)
  },

  changeStep: ({ commit }, index) => {
    commit('changeIndex', index)
  }
}

const mutations = {
  changeIndex (state, index) {
    state.index = index
  }
}

export default {
  state,
  actions,
  mutations
}
